import React, { useEffect, useState } from "react";
import "./ProductFilter.scss";
import { ControlOutlined, SearchOutlined } from "@ant-design/icons";
import { faMap } from "@fortawesome/free-regular-svg-icons";
import largeModeImg from "@assets/icons/large-icons.svg";
import smallModeImg from "@assets/icons/small-icons.svg";
import { ReactComponent as HayIcon } from "@assets/icons/hayIcon.svg";
import { ReactComponent as SeedIcon } from "@assets/icons/seedIcon.svg";
import { ReactComponent as StrawIcon } from "@assets/icons/strawIcon.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row, Col, Input, Select, Button } from "antd";
import { useNavigate } from "react-router-dom";
import Helpers from "@utils/Helpers";
import Suggestion from "@components/Suggestion/Suggestion";
import FilterControl from "@components/FilterControl/FilterControl";
import { IProductFilter } from "@utils/Interfaces";
import Validates from "@utils/Validates";
const { Option } = Select;

let debounceTimer: any;

const ProductFilter: React.FC<IProductFilter> = ({
  isOpenMap,
  setIsOpenMap,
  isLargeMode,
  setIsLargeMode,
  searchParam,
  setSearchParam,
  componentIn,
  submit,
}) => {
  const [selectChange, setSelectChange] = useState(false);
  const [searchResult, setSearchResult] = useState<any[]>([]);
  const [isOpenSuggestion, setIsOpenSuggestion] = useState(false);
  const [isFilterControlOpen, setIsFilterControlOpen] = useState(false);
  const navigate = useNavigate();

  const categoryList = [
    {
      id: 1,
      name: "Hay",
      image: <HayIcon className="image" />,
    },
    {
      id: 2,
      name: "Straw",
      image: <StrawIcon className="image" />,
    },
    {
      id: 3,
      name: "Seed",
      image: <SeedIcon className="image" />,
      disabled: true,
    },
  ];

  const handleSearchInputChange = (key: string, value: any) => {
    if (key === "quantity") {
      value = Validates.validateNumberForm(value);
    }
    setSearchParam({
      ...searchParam,
      [key]: key === "quantity" ? (value === "" ? null : value) : value || "",
    });
    if (
      key !== "query" &&
      key !== "address" &&
      componentIn === "productCatalog"
    ) {
      setSelectChange(true);
      return;
    }
    submit?.();
  };

  useEffect(() => {
    if (selectChange) {
      handleRedirectToSearchPage();
    }
  }, [selectChange]);

  const handleRedirectToSearchPage = () => {
    const encodedParams = encodeURIComponent(JSON.stringify(searchParam));
    navigate(`/search?params=${encodedParams}`);
  };

  const handleClearKeyWord = () => {
    setSearchParam({
      query: "",
      address: "",
      radius: "100",
      type: null,
      categories_id: [1, 2],
      location: null,
      selling_method: null,
      quantity: null,
      shape: null,
      filters: { ...searchParam.filters },
    });
    navigate("/products");
  };

  return (
    <>
      <div className="ProductFilter">
        <div className="filter-wrap">
          <div className="sort-group mt-4">
            <Row gutter={[12, 12]}>
              <Col span={6}>
                <div className="category-list">
                  {categoryList.map((item, index) => {
                    return (
                      <div
                        key={item.id}
                        className={`category-item ${
                          searchParam?.categories_id.includes(item.id) &&
                          item.id !== 3
                            ? "selected"
                            : ""
                        } ${componentIn === "myProduct" && "my-product"}`}
                        onClick={() => {
                          if (item.id !== 3) {
                            const currentIds = searchParam?.categories_id || [];
                            const isCurrentlyOnlySelected =
                              currentIds.length === 1 &&
                              currentIds.includes(item.id);
                            const updatedCategoryIds = isCurrentlyOnlySelected
                              ? [1, 2]
                              : [item.id];

                            setSearchParam({
                              ...searchParam,
                              categories_id: updatedCategoryIds,
                            });
                          }
                        }}
                      >
                        <div className="d-flex align-items-center category-content">
                          {item.id === 3 && (
                            <div className="watermark">
                              <div className="background"></div>
                              <p className="coming-soon">COMING SOON</p>
                            </div>
                          )}
                          <div className="category-title">
                            <div className="category-image">{item.image}</div>
                            <span
                              className="category-name"
                              style={{
                                marginLeft: "0",
                              }}
                            >
                              {item.name}
                            </span>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </Col>
              <Col span={12}>
                <Input
                  size={"large"}
                  variant="filled"
                  placeholder="Search"
                  suffix={
                    <Button
                      icon={<SearchOutlined />}
                      size="small"
                      color="default"
                      variant="filled"
                      className="search-btn"
                      onClick={() => {
                        if (
                          searchParam.query !== "" &&
                          !window.location.pathname.includes("search") &&
                          !submit
                        ) {
                          handleRedirectToSearchPage();
                        } else {
                          submit?.();
                        }
                      }}
                    />
                  }
                  className="search-input"
                  value={searchParam.query}
                  onChange={(e) =>
                    handleSearchInputChange("query", e.target.value)
                  }
                />
              </Col>
              <Col span={3}>
                <div className="view-mode">
                  <div
                    onClick={() => setIsLargeMode(true)}
                    className={`large-mode ${isLargeMode && "mode"}`}
                  >
                    <img src={largeModeImg} alt="large-mode" />
                  </div>
                  <div
                    onClick={() => setIsLargeMode(false)}
                    className={`small-mode ${!isLargeMode && "mode"}`}
                  >
                    <img src={smallModeImg} alt="small-mode" />
                  </div>
                </div>
              </Col>
              <Col span={3}>
                <Button
                  size={"large"}
                  variant="filled"
                  className={`map-btn ${isOpenMap && "active"}`}
                  icon={<FontAwesomeIcon icon={faMap} />}
                  onClick={() => setIsOpenMap(!isOpenMap)}
                >
                  Map
                </Button>
              </Col>
              <Col span={6}>
                <Button
                  className="open-filter-btn"
                  size="large"
                  color="default"
                  variant="filled"
                  onClick={() => setIsFilterControlOpen(true)}
                  icon={<ControlOutlined />}
                >
                  Filter
                </Button>
              </Col>
              <Col span={6}>
                <div className="map-search-input">
                  <Input
                    size={"large"}
                    variant="filled"
                    placeholder="Location"
                    className="search-input"
                    value={searchParam.address}
                    addonAfter={
                      <Input
                        disabled={
                          searchParam.location === "" || !searchParam.location
                        }
                        value={searchParam.radius}
                        onChange={(e) =>
                          handleSearchInputChange("radius", e.target.value)
                        }
                        className="radius-input"
                        variant="borderless"
                        suffix="km"
                      />
                    }
                    onChange={(e) => {
                      const query = e.target.value;
                      setIsOpenSuggestion(true);
                      if (query === "") {
                        setIsOpenSuggestion(false);
                      }
                      clearTimeout(debounceTimer);
                      debounceTimer = setTimeout(async () => {
                        const result = await Helpers.handleSearchLocation(
                          query
                        );
                        setSearchResult(result);
                      }, 300);
                      handleSearchInputChange("address", e.target.value);
                    }}
                  />
                  {isOpenSuggestion && (
                    <Suggestion
                      searchResult={searchResult}
                      onSelect={(item) => {
                        setIsOpenSuggestion(false);
                        setSearchParam({
                          ...searchParam,
                          address: item.display_name,
                          location: [
                            parseFloat(item.lat),
                            parseFloat(item.lon),
                          ],
                        });
                        if (componentIn === "productCatalog") {
                          setSelectChange(true);
                        }
                      }}
                    />
                  )}
                </div>
              </Col>
              <Col span={6}>
                {searchParam.categories_id.length === 2 ? (
                  <Select
                    size={"large"}
                    variant="filled"
                    placeholder="Type"
                    className="search-input"
                    value={searchParam.type}
                    onChange={(value) => handleSearchInputChange("type", value)}
                  >
                    <Option value="Alfalfa">Alfalfa</Option>
                    <Option value="Alfalfa mix">Alfalfa Mix</Option>
                    <Option value="Barley Straw">Barley Straw</Option>
                    <Option value="Brome Grass">Brome Grass</Option>
                    <Option value="Canola Straw">Canola Straw</Option>
                    <Option value="Clover">Clover</Option>
                    <Option value="Flax Straw">Flax Straw</Option>
                    <Option value="Grass mix">Grass mix</Option>
                    <Option value="Oat Straw">Oat Straw</Option>
                    <Option value="Orchard Grass">Orchard Grass</Option>
                    <Option value="Rye Straw">Rye Straw</Option>
                    <Option value="Sainfoin">Sainfoin</Option>
                    <Option value="Timothy">Timothy</Option>
                    <Option value="Wheat Straw">Wheat Straw</Option>
                    <Option value="Others">Others</Option>
                  </Select>
                ) : searchParam.categories_id.includes(2) ? (
                  <Select
                    size={"large"}
                    variant="filled"
                    placeholder="Type"
                    className="search-input"
                    value={searchParam.type}
                    onChange={(value) => handleSearchInputChange("type", value)}
                  >
                    <Option value="Barley Straw">Barley Straw</Option>
                    <Option value="Canola Straw">Canola Straw</Option>
                    <Option value="Flax Straw">Flax Straw</Option>
                    <Option value="Oat Straw">Oat Straw</Option>
                    <Option value="Rye Straw">Rye Straw</Option>
                    <Option value="Wheat Straw">Wheat Straw</Option>
                    <Option value="Others">Others</Option>
                  </Select>
                ) : (
                  <Select
                    size={"large"}
                    variant="filled"
                    placeholder="Type"
                    className="search-input"
                    value={searchParam.type}
                    onChange={(value) => handleSearchInputChange("type", value)}
                  >
                    <Option value="Alfalfa">Alfalfa</Option>
                    <Option value="Alfalfa mix">Alfalfa Mix</Option>
                    <Option value="Brome Grass">Brome Grass</Option>
                    <Option value="Clover">Clover</Option>
                    <Option value="Grass mix">Grass Mix</Option>
                    <Option value="Orchard Grass">Orchard Grass</Option>
                    <Option value="Sainfoin">Sainfoin</Option>
                    <Option value="Timothy">Timothy</Option>
                    <Option value="Others">Others</Option>
                  </Select>
                )}
              </Col>
              <Col span={3}>
                <Input
                  size={"large"}
                  variant="filled"
                  placeholder="Quantity"
                  className="search-input"
                  value={searchParam.quantity}
                  onChange={(e) =>
                    handleSearchInputChange("quantity", e.target.value)
                  }
                />
              </Col>

              <Col span={3}>
                <Button
                  size={"large"}
                  className="filter-btn"
                  onClick={handleClearKeyWord}
                >
                  Clear All
                </Button>
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <FilterControl
        isOpen={isFilterControlOpen}
        setIsOpen={setIsFilterControlOpen}
        searchParam={searchParam}
        setSearchParam={setSearchParam}
        submit={submit}
        componentIn={componentIn}
      />
    </>
  );
};

export default ProductFilter;
